import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Spacing, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ColorContainerContentTextConverter extends CmsConverterService<ColorContainerContentTextData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      label: formData.st_label ?? defaultTextInput,
      headline: formData.st_headline ?? defaultTextInput,
      text: formData.st_color_container_element_content_text ?? defaultTextInput,
      textCentered: formData?.st_centered_text?.value ?? false,
      spacing: {
        top: formData.st_spacing_bottom?.value?.identifier ?? '',
        bottom: formData.st_spacing_top?.value?.identifier ?? ''
      },
    }
  }
}

export const COLOR_CONTAINER_CONTENT_TEXT_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ColorContainerContentTextData>>('ColorContainerContentTextConverter')

export interface ColorContainerContentTextData extends ConvertedComponentData {
  label: TextInput;
  text: TextInput;
  textCentered: boolean;
  headline: TextInput;
  spacing: Spacing;
}
